var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnResumedSubscription(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 116.459,
    height: 116.998,
    viewBox: "0 0 116.459 116.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "bg-circle",
    x: 0,
    y: 0,
    width: 116.459,
    height: 116.998,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-resumed-subscription",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn-billing-overview"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12345",
    "data-name": "Path 12345",
    d: "M1248.764,43.839h-11.711a2.9,2.9,0,0,1-2.927-2.848h0a2.9,2.9,0,0,1,2.927-2.848h11.711a2.9,2.9,0,0,1,2.928,2.848h0A2.9,2.9,0,0,1,1248.764,43.839Z",
    transform: "translate(-1196.549 -2.351)",
    fill: "#3d9de3"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#bg-circle)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "bg-circle-2",
    "data-name": "bg-circle",
    cx: 49.23,
    cy: 49.499,
    rx: 49.23,
    ry: 49.499,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19007",
    "data-name": "Group 19007",
    transform: "translate(32.602 27.872)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12296",
    "data-name": "Path 12296",
    d: "M.009,0S.238,3.337,3.518,7.312c3.608,4.373,4.735,5.274,12.838,4.875,9.381-.566,17.915.855,19.24,4.382L.009,16.087S-.011.164.009,0Z",
    transform: "translate(16.628 0) rotate(90)",
    fill: "#3d9de3",
    opacity: 0.093
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12303",
    "data-name": "Path 12303",
    d: "M.008,0s.2,2.177,3.1,4.771C6.3,7.624,7.138,7.319,14.8,6.98c8.288-.369,19.879.341,21.049,2.643L.008,9.283S-.01.107.008,0Z",
    transform: "translate(9.623 0) rotate(90)",
    fill: "#3d9de3",
    opacity: 0.175
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19008",
    "data-name": "Group 19008",
    transform: "translate(69.479 75.034) rotate(180)",
    opacity: 0.467
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12296-2",
    "data-name": "Path 12296",
    d: "M.005,0S.234,1.7,3.5,3.726C7.094,5.954,8.044,5.717,16.679,5.452c9.344-.288,22.4,3.019,23.722,4.817H.026S-.014.083.005,0Z",
    transform: "translate(11.042) rotate(90)",
    fill: "#3d9de3",
    opacity: 0.125
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12303-2",
    "data-name": "Path 12303",
    d: "M.005,0S.234,1.367,3.5,3C7.094,4.788,8.044,4.6,16.679,4.384c9.344-.232,22.4,2.428,23.722,3.873H.026S-.014.067.005,0Z",
    transform: "translate(8.258) rotate(90)",
    fill: "#3d9de3",
    opacity: 0.175
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12346",
    "data-name": "Path 12346",
    d: "M1247.05,49.839h-10.339a2.734,2.734,0,0,1-2.584-2.848h0a2.734,2.734,0,0,1,2.584-2.848h10.339a2.734,2.734,0,0,1,2.585,2.848h0A2.734,2.734,0,0,1,1247.05,49.839Z",
    transform: "translate(-1194.493 0.193)",
    fill: "#3d9de3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25542",
    "data-name": "Path 25542",
    d: "M1247.05,49.839h-10.339a2.734,2.734,0,0,1-2.584-2.848h0a2.734,2.734,0,0,1,2.584-2.848h10.339a2.734,2.734,0,0,1,2.585,2.848h0A2.734,2.734,0,0,1,1247.05,49.839Z",
    transform: "translate(-1194.493 -8.351)",
    fill: "#3d9de3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12347",
    "data-name": "Path 12347",
    d: "M1270.1,32.415l-4.391-4.272-4.392,4.272-4.392-4.272-4.391,4.272-4.392-4.272-4.392,4.272-4.391-4.272-4.391,4.272-4.392-4.272V68.015h-5.856a2.9,2.9,0,0,0-2.927,2.848v5.7a8.654,8.654,0,0,0,8.782,8.544h35.132a8.655,8.655,0,0,0,8.782-8.544V28.143Zm-10.1,48.7H1229.52c-1.864,0-3.387-2.095-3.387-4.655V71.808H1260Zm10.092-3.543c0,1.665-1.474,3.608-3.234,3.608s-3.165-1.944-3.165-3.608V71.524a3.126,3.126,0,0,0-3.2-3.026h-25.6V35.212h35.2Z",
    transform: "translate(-1201.787 -6.591)",
    fill: "#0076cc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1616",
    "data-name": "Ellipse 1616",
    cx: 2.928,
    cy: 2.848,
    rx: 2.928,
    ry: 2.848,
    transform: "translate(58.071 35.791)",
    fill: "#3d9de3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1617",
    "data-name": "Ellipse 1617",
    cx: 2.928,
    cy: 2.848,
    rx: 2.928,
    ry: 2.848,
    transform: "translate(58.071 44.335)",
    fill: "#3d9de3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "dots",
    transform: "translate(5.235 10.854)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16132",
    "data-name": "Group 16132",
    transform: "translate(0 15.181)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1262",
    "data-name": "Ellipse 1262",
    cx: 0.922,
    cy: 0.925,
    rx: 0.922,
    ry: 0.925,
    transform: "translate(86.358 28.534)",
    fill: "#e7e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1263",
    "data-name": "Ellipse 1263",
    cx: 0.922,
    cy: 0.925,
    rx: 0.922,
    ry: 0.925,
    transform: "translate(7.229 0)",
    fill: "#8c94c9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1264",
    "data-name": "Ellipse 1264",
    cx: 0.922,
    cy: 0.925,
    rx: 0.922,
    ry: 0.925,
    transform: "translate(0 34.591)",
    fill: "#97d3f1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16131",
    "data-name": "Group 16131",
    transform: "translate(36.295 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1265",
    "data-name": "Ellipse 1265",
    cx: 0.922,
    cy: 0.925,
    rx: 0.922,
    ry: 0.925,
    transform: "translate(3.282 76.507)",
    fill: "#8c94c9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1266",
    "data-name": "Ellipse 1266",
    cx: 0.922,
    cy: 0.925,
    rx: 0.922,
    ry: 0.925,
    transform: "translate(21.677)",
    fill: "#97d3f1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1267",
    "data-name": "Ellipse 1267",
    cx: 0.922,
    cy: 0.925,
    rx: 0.922,
    ry: 0.925,
    transform: "translate(0 6.988)",
    fill: "#e7e6e6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icn-green-check",
    transform: "translate(61.083 12.74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1431",
    "data-name": "Ellipse 1431",
    fill: "#08a246",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.904,
    cy: 18.048,
    rx: 17.904,
    ry: 18.048,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.904,
    cy: 18.048,
    rx: 16.904,
    ry: 17.048,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2067",
    "data-name": "Path 2067",
    d: "M5825.15,587.08l4.729,5.488,10.437-10.481",
    transform: "translate(-5815.058 -569.397)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnResumedSubscription);
export default __webpack_public_path__ + "static/media/icn-resumed-subscription.66dad312056d45688c166ddb9ca1f786.svg";
export { ForwardRef as ReactComponent };